
/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InputButton from '../../../../../components/ZUILib/InputButton';
import * as predeterminedListsActions from '../actions';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import ApplyCSS from '../../../../../components/ApplyCSS';
import Filter from './Filter';
import commonUtil from '../../../../../utils/commonUtil';
import Tagging from '../../../../../components/Tagging/Tagging';
import RadioButton from '../../../../../components/ZUILib/RadioButton';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'PredeterminedLists';


const {
  getpredeterminedListPageHeaderInfo,
  getPredeterminedListPageItemsInfo,

} = predeterminedListsActions;

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,

}),

  {
    ...predeterminedListsActions,
  })

class PredeterminedListsDetailsWap extends Component {
  constructor(props) {
    super(props);
    this.repoId = (this.props.params && this.props.params.repoId) ? this.props.params.repoId : '';
    this.currentPage = 1;
    this.state = {
      sortingType: '',
      filteredData: '',
    };
    this.catName = [];
    this.deliveryMode = 'physical';
    this.itemName = '';
  }
  backToAdmin = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Ir a mi mesa de regalos';
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: this.props.eventId }));
    this.addGiftModal.handleHide();
  }
  handleAddListToMyList = (repoId, itemName, deliveryMode) => {
    const _dataLayer = {};
    _dataLayer.event = 'evGiftList';
    _dataLayer.nameList = itemName;
    _dataLayer.selectOption = 'Agregar Artículos a mi lista';
    this.tagging.applyGTM('evGiftList', _dataLayer);
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregar artículos a mi lista';
    dataLayer.eventLabel = 'Regalos '+deliveryMode;
    dataLayer.dimension77 = 'Preferencia de regalo';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    this.props.onAddListToMyList(repoId, this.props.eventId, deliveryMode);
  }
  showAddModalType = () =>{
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregar artículos a mi lista';
    dataLayer.eventLabel = this.itemName;
    dataLayer.dimension77 = 'Listas Predeterminadas';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    const dataLayer2 = {};
    dataLayer2.event =  'Mesa de Regalos';
    dataLayer2.eventCategory= 'Mesa de Regalos';
    dataLayer2.eventAction = 'Agregar artículos a mi lista';
    dataLayer2.eventLabel = 'Preferencia de regalo';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer2);
    this.addGiftModalType.handleShow();
  }
  showAddModal = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Regalos '+ this.deliveryMode;
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    this.addGiftModal.handleShow();
  }
  _setDeliveryMode = (ref) => {
    this.deliveryMode = ref.value;   
  }
  infiniteScrollCondition = (props) => {
    const itemsCount = this.props.predeterminedItemsDetailsInfo && this.props.predeterminedItemsDetailsInfo.totalRecords ? this.props.predeterminedItemsDetailsInfo.totalRecords : 0;
    const categoryInfo = this.itemsInfo;
    let recordsCount = 0;
    if (categoryInfo && categoryInfo.length > 0) {
      // categoryInfo.forEach((item) => {
      //   const count = item && item.length ? item.length : 0;
      //   recordsCount += count;
      // });
      recordsCount = categoryInfo.length;
    }
    return ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 500)
        && recordsCount < itemsCount
        && !props.loadingItems);
  }
  onScroll = (e) => {
    e.preventDefault(); // try
    if (this.infiniteScrollCondition(this.props)) {
      this.currentPage = this.currentPage + 1;
      this.props.getPredeterminedListPageItemsInfo(this.props.params.repoId, this.currentPage.toString());
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, false);
    this.props.getpredeterminedListPageHeaderInfo(this.props.params.repoId);
    this.props.getPredeterminedListPageItemsInfo(this.props.params.repoId, '1');
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.loadingItems && !nextProps.loadingItems && nextProps.predeterminedItemsDetailsInfo) {
      const currentPage = nextProps.predeterminedItemsDetailsInfo && nextProps.predeterminedItemsDetailsInfo.currentPage ? nextProps.predeterminedItemsDetailsInfo.currentPage : '1';
      const currentItemsInfo = currentPage !== '1' && this.itemsInfo ? this.itemsInfo : [];
      const itemsInfo = nextProps.predeterminedItemsDetailsInfo && nextProps.predeterminedItemsDetailsInfo.itemsInfo ? nextProps.predeterminedItemsDetailsInfo.itemsInfo : [];

      this.itemsInfo = [...currentItemsInfo, ...itemsInfo];
    }

    this.predeterminedItemInfo = nextProps.predeterminedHeaderInfo ?
      nextProps.predeterminedHeaderInfo.predeterminedItemInfo : null;

    this.categoryList = nextProps.predeterminedItemsDetailsInfo ?
      nextProps.predeterminedItemsDetailsInfo.categoryList : null;

    this.categoryItemsInfo = nextProps.predeterminedItemsDetailsInfo ?
      nextProps.predeterminedItemsDetailsInfo.itemsInfo : null;
  }


  generateHeaderInfo = (predeterminedItemInfo) => {
    const label = this.props.labels;
    const addListToMyList = {
      name: 'Agregar artículos a mi lista',
      style: 'btnPrimary size-Full',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.addtolist.button.label'),
      onClickHandler: this.handleAddListToMyList,
    };
    const goToMyGiftTable = {
      name: 'Ir a mi mesa de regalos',
      style: 'btnPrimarySpecial btnFull',
      type: 'button',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gotogifts.button.label'),
      onClickHandler: this.backToAdmin,
    };
    const continueAddingGiftType = {
        name: 'Continuar',
        style: 'btnPrimary size-Full',
        type: 'button',
        value: 'Continuar',
      };
    const addPredeterminedItemInfo = this.props.addPredeterminedItemInfo ? this.props.addPredeterminedItemInfo[0] : null;
    const _typeListPredetermined = {
        htmlId: 'typeListPredetermined',
        title: 'Tipo Lista',
        displayName: 'Tipo Lista',
        name: 'typeListPredetermined',
        defaultValue: 'physical',
        options: [
          {
            id: 'typePhysical',
            value: 'physical',
            title: 'Regalos fisicos',
            displayName: 'Regalos fisicos',
            labelResourceId: 'Regalos fisicos',
            selected: true,
          },
          {
            id: 'typeElectronic',
            value: 'electronic',
            title: 'Regalos electrónicos',
            displayName: 'Regalos electrónicos',
            labelResourceId: 'Regalos electronicos',
          },
        ],
      };
    if (predeterminedItemInfo) {
      return predeterminedItemInfo.map((predeterminedItemInfor, index) => {
        const newAddListToMyList = Object.assign({}, addListToMyList);
        newAddListToMyList.onClickHandler = () => { this.itemName =predeterminedItemInfor.itemName;  this.showAddModalType();};
        const newAddListInGiftListType = Object.assign({}, continueAddingGiftType);
        newAddListInGiftListType.onClickHandler = () => {this.itemName =predeterminedItemInfor.itemName; this.addGiftModalType.handleHide(); this.showAddModal(); this.handleAddListToMyList(predeterminedItemInfor.repoId, predeterminedItemInfor.itemName,this.deliveryMode); };
        
        return (<div key={index}>
          <div className="col-sm-12">
            <Tagging ref={tagging => this.tagging = tagging} />
            <h1 className="titleSection">{predeterminedItemInfor.itemName.toUpperCase()} </h1>
            <h2 className="subtitleModule">{predeterminedItemInfor.noOfItems} <span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.total.articles')}</span></h2>
            <h2 className="subtitleModule">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.gifts.label1')}<span> {commonUtil.getCurrency(predeterminedItemInfor.minPrice)} </span> {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.gifts.label2')} <span> {commonUtil.getCurrency(predeterminedItemInfor.maxPrice)} </span></h2>
            <h3>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.total.label')}<span>{commonUtil.getCurrency(predeterminedItemInfor.totalPrice)}</span></h3>
          </div>
          <div className="col-xs-12">
            <InputButton buttonAttr={newAddListToMyList} />
          </div>
          <div id="myModalAddList">
          <ModalPopover
              ref={add => this.addGiftModalType = add}
              isModal="true" outerClass="modal-sm" modalId="predeter-con-pop"
            >
             <div className="container">
              <div className="row">
                <div className="col-md-12">
                <button className="close" id="closeModal" type="button" data-dismiss="modal">×</button>
                    <p><h4>Preferencia de regalo</h4></p>
                    <hr/>
                   
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-offset-3">
                        {_typeListPredetermined.options.map(option => (
                        <p>
                            <RadioButton displayName={option.displayName} radioCssClass={'radio'} name={_typeListPredetermined.name} onChangeFunction={this._setDeliveryMode} value={option.value} checked={option.selected ? _typeListPredetermined.defaultValue === option.value : false} />
                        
                        </p>
                        ))}
                        <p>
                            <br/>
                        <InputButton buttonAttr={newAddListInGiftListType} />
                        </p>
                    </div>
                </div>
                </div>
            </ModalPopover>
            <ModalPopover
              ref={add => this.addGiftModal = add}
              isModal="true" outerClass="modal-lg"
            >
              <button className="close" id="closeModal" type="button" data-dismiss="modal">×</button>
              <div className="alert-container"><i className="icon-estado_de_mensaje_aprobado" />
                <p className="txt-alert">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.message')}  &nbsp; 1 <span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermined.list.label')}</span>&nbsp; {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.message1')}</p>
              </div>
              {addPredeterminedItemInfo ?
                <div className="row modal-product">
                  <div className="col-xs-12">
                    <div className="row">
                      <div className="col-xs-6">
                        <div className="imgList">
                          {addPredeterminedItemInfo.imageURL ? <img src={addPredeterminedItemInfo.imageURL} className="img-responsive" /> : <img src={commonUtil.getAssetURL() + '/images/ooooooooooo.jpg'} className="img-responsive" />}
                        </div>
                      </div>
                      <div className="col-xs-6">
                        <div className="descriptionList">
                          
                          <h4 className="title">{addPredeterminedItemInfo && addPredeterminedItemInfo.itemName && addPredeterminedItemInfo.itemName.toUpperCase()}</h4>
                          <p className="articles"><span>{addPredeterminedItemInfo.noOfItems}</span><span> {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.total.articles')}</span></p>
                          <p className="priceRange"><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gifts.label1')} {commonUtil.getCurrency(addPredeterminedItemInfo.minPrice)} {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gifts.label2')} {commonUtil.getCurrency(addPredeterminedItemInfo.maxPrice)}</span></p>
                          <p><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.total.label')}</span><span className="value">{commonUtil.getCurrency(addPredeterminedItemInfo.totalPrice)} {addPredeterminedItemInfo.itemId}</span></p>
                          <p className="priceRange giftPreference"><span>Preferencia de regalo:</span></p>
                          <p className="giftElectronicPhysical"><span>Regalos {this.deliveryMode == 'electronic' ? 'electrónicos' : 'físicos' }</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 buttons">
                      <InputButton buttonAttr={goToMyGiftTable} />
                    </div>
                  </div>
                </div> : null}
            </ModalPopover>

          </div>
        </div>);
      });
    }

    return null;
  }


  show = () => {
    this.filter.showModal();
  }
  render() {
    if (!this.predeterminedItemInfo && !this.categoryList && !this.itemsInfo) {
      return null;
    }
    const categoryList = this.categoryList ? this.categoryList.map(selectedCelebratedName => ({ id: selectedCelebratedName.catId, value: selectedCelebratedName.catName })) : [];
    const label = this.props.labels;


    const filterButton = {
      name: 'Filtrar',
      id: 'filter',
      style: 'btnSecondarySpecial size-Full',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.filter.by.label'),
      onClickHandler: this.show,
    };

    return (
      <div>
        <div className="row itemsDefaultList">
          <ApplyCSS pageName={pageName} />

          <Filter
            getPredeterminedListPageItemsInfo={this.props.getPredeterminedListPageItemsInfo}
            getpredeterminedListPageHeaderInfo={this.props.getpredeterminedListPageHeaderInfo}
            categoryList={this.categoryList ? this.categoryList : null}
            ref={filter => this.filter = filter}
            repoId={this.repoId}
            label={label}

          />

          {this.generateHeaderInfo(this.predeterminedItemInfo)}


          <div className="col-xs-6 filterButton">
            <InputButton buttonAttr={filterButton} />
          </div>
          <div className="col-sm-12">
            <div className="defaultListPagination" />
          </div>
        </div>
        <div className="row">

          <div className="defaultListProducts">

            {this.itemsInfo && this.itemsInfo.map(info => (
              <div className="col-xs-12 product" >
                <div className="col-xs-6">
                  {info.imageURL ? <img src={info.imageURL} /> : <img src={commonUtil.getAssetURL() + '/images/89843855 (1).jpg'} /> }
                </div>
                <div className="col-xs-6">
                  <p className="informativeText">{info.itemName}</p>
                  <p className="descriptiveTextSecond">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.prodcut.code.label')}<span>{info.productCode}</span></p>
                  <p className="quantityAndGuest">{commonUtil.getCurrency(info.price)}</p>
                </div>
              </div>

                ))}
          </div>
        </div>
      </div>
    );
  }
      }
const mapStateToProps = state => ({
  myData: state,

  loadingItems: state.predeterminedLists.loadingItems,
  predeterminedHeaderInfo: state.predeterminedLists && state.predeterminedLists.data && state.predeterminedLists.data.predeterminedHeaderInfo ? state.predeterminedLists.data.predeterminedHeaderInfo : undefined,
  predeterminedItemsDetailsInfo: state.predeterminedLists && state.predeterminedLists.data && state.predeterminedLists.data.predeterminedItemsDetailsInfo ? state.predeterminedLists.data.predeterminedItemsDetailsInfo : undefined,

});
const matchDispatchToProps = dispatch => bindActionCreators({

  getpredeterminedListPageHeaderInfo,
  getPredeterminedListPageItemsInfo,

}, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(PredeterminedListsDetailsWap);

